'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SomeHash$() {
  this.cc4 = null;
  this.cc5 = false;
  this.cc2 = null;
  this.cc3 = false;
}
export { $c_Lpresto_types$SomeHash$ as $c_Lpresto_types$SomeHash$ };
$p = $c_Lpresto_types$SomeHash$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SomeHash$;
/** @constructor */
function $h_Lpresto_types$SomeHash$() {
}
export { $h_Lpresto_types$SomeHash$ as $h_Lpresto_types$SomeHash$ };
$h_Lpresto_types$SomeHash$.prototype = $p;
$p.a2H = (function() {
  if ((!this.cc5)) {
    this.cc4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cc5 = true;
  }
  return this.cc4;
});
$p.a2D = (function() {
  if ((!this.cc3)) {
    this.cc2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.cc3 = true;
  }
  return this.cc2;
});
var $d_Lpresto_types$SomeHash$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SomeHash$, "presto.types$SomeHash$", ({
  a27: 1
}));
export { $d_Lpresto_types$SomeHash$ as $d_Lpresto_types$SomeHash$ };
var $n_Lpresto_types$SomeHash$;
function $m_Lpresto_types$SomeHash$() {
  if ((!$n_Lpresto_types$SomeHash$)) {
    $n_Lpresto_types$SomeHash$ = new $c_Lpresto_types$SomeHash$();
  }
  return $n_Lpresto_types$SomeHash$;
}
export { $m_Lpresto_types$SomeHash$ as $m_Lpresto_types$SomeHash$ };
//# sourceMappingURL=presto.types$-Some-Hash$.js.map
